import { Inline, vars, Text, textVariants } from '@etg/wings';
import { css } from '@eti/styles';
import { Check } from '@phosphor-icons/react';

const checkStyles = css`
  color: ${vars.colors.signal.positive.foreground};
`;

const textStyles = css`
  width: calc(100% - 28px);
`;

interface SelectedTripSellingPointItemProps {
  label: string;
}

const SelectedTripSellingPointItem = ({ label }: SelectedTripSellingPointItemProps) => {
  return (
    <Inline as="li" data-testid="selected-trip-banner-usp-selling-point-item" spacing={8}>
      <Check aria-hidden className={checkStyles} data-testid="check-icon" size={20} weight="bold" />
      <Text className={textStyles} variant={textVariants._14_BOLD}>
        {label}
      </Text>
    </Inline>
  );
};

export default SelectedTripSellingPointItem;
